var ol = require('openlayers');

var Utils = require('../../Utils/DescartesUtils');
var FeatureSelection = require('./FeatureSelection');

require('./css/RectangleSelection.css');

/**
 * Class: Descartes.Tool.Selection.RectangleSelection
 * Classe définissant un bouton permettant la sélection d'objets par dessin d'un polygone quelconque sur la carte.
 *
 * Hérite de:
 *  - <Descartes.Tool.Selection.FeatureSelection>
 */
var Class = Utils.Class(FeatureSelection, {

    /**
     * Constructeur: Descartes.Tool.Selection.CircleSelection
     * Constructeur d'instances
     */
    initialize: function () {
        FeatureSelection.prototype.initialize.apply(this, arguments);

        this.interaction = new ol.interaction.Draw({
            type: 'Circle',
            source: this.getSource(),
            geometryFunction: ol.interaction.Draw.createBox(),
            style: this.styleFunction
        });
        this.interaction.set('id', 'RectangleSelection_' + Utils.createUniqueID());
        this.interaction.setActive(false);
        this.interaction.on('drawend', this.onDrawEnd.bind(this), this);
    },

    onDrawEnd: function (event) {
        if (this.persist) {
            this.getSource().clear();
        }
        this.executeQuery(event.feature);
    },

    CLASS_NAME: 'Descartes.Tool.Selection.RectangleSelection'
});

module.exports = Class;



//////////////////
// WEBPACK FOOTER
// ./src/DMap/Tool/Selection/RectangleSelection.js
// module id = 240
// module chunks = 0